import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getRefCode, captureRefFromUrl, clearRefCode } from "@/lib/referral";
import { Gift, X } from "lucide-react";

export default function ReferrerBadge() {
  const location = useLocation();
  const [code, setCode] = useState(() => {
    if (typeof window !== "undefined") {
      captureRefFromUrl();
      return getRefCode();
    }
    return "";
  });
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    captureRefFromUrl();
    setCode(getRefCode());
  }, [location.search]);

  if (!code || dismissed) return null;
  // Hide on admin/login/callback
  if (location.pathname.startsWith("/admin") || location.pathname === "/login") return null;

  return (
    <div className="w-full text-white" style={{ background: "linear-gradient(90deg, #0F5132, #1F6B45)" }} data-testid="referrer-badge">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-2.5 flex items-center gap-3 flex-wrap text-sm">
        <span className="inline-flex w-7 h-7 rounded-full items-center justify-center" style={{ background: "rgba(212,175,55,0.2)", color: "var(--asure-gold)" }}>
          <Gift size={14} />
        </span>
        <span className="font-medium">
          Invited by a friend · your discount is unlocked with code <span className="font-bold tracking-wider" style={{ color: "var(--asure-gold)" }}>{code}</span>
        </span>
        <span className="hidden md:inline text-white/70 text-xs">— your enquiry will be linked automatically</span>
        <button
          aria-label="Dismiss"
          className="ml-auto text-white/70 hover:text-white"
          onClick={() => { clearRefCode(); setDismissed(true); }}
          data-testid="referrer-badge-close"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
